import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from '@app/shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class ModuleService {

  constructor(private api: ApiService) {
  }

  getModules(sentData: any): Observable<any> {
    return this.api.post('Modules/getModules', sentData)
  }

  changePassword(sentData: any): Observable<any> {
    return this.api.post('UserManagement/changePassword', sentData)
  }

  getLogo(): Observable<any> {
    return this.api.post('InstitutionManagement/getLogo')
  }

}
